
import cacaAoTesouro from './CacaAoTesouroReducer';


export default cacaAoTesouro;
